import "./styles.scss";
import { HomePage } from "../../js/homepage";

new HomePage();
